<template>
    <v-card flat class="sub-site-wrapper">
        <div v-if="agencyStats" class="table-statistics-wrapper">
            <v-row>
                <v-col cols="12" sm="3">
                    <div v-if="agencyStats" class="statistics-text-box elevation-3">
                        <h5>Anzahl aktiver Agenturen:</h5>
                        <h3>{{ agencyStats.numberOfAgencies }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="agencyStats" class="statistics-text-box elevation-3">
                        <h5>Gesamtzahl der gebuchten Slots:</h5>
                        <h3>{{ agencyStats.totalPaidSlots }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="agencyStats" class="statistics-text-box elevation-3">
                        <h5>Durchschnittliche Slotanzahl pro Agentur:</h5>
                        <h3>{{ agencyStats.averageAmountSlots.toFixed(2) }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="agencyStats" class="statistics-text-box elevation-3">
                        <h5>Median der Slots pro Agentur:</h5>
                        <h3>{{ agencyStats.medianAmountSlots }}</h3>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="3">
                    <div v-if="statisticsFromStatistics" class="statistics-text-box elevation-3">
                        <h5>Prozent der aktiv genutzten Slots:</h5>
                        <h3>{{ statisticsFromStatistics.percentageUsedSlots.toFixed(2) }} %</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="agencyStats" class="statistics-text-box elevation-3">
                        <h5>Durchschnittlich aktive Slots im 10er Segment:</h5>
                        <h3>{{ statisticsFromStatistics.percentageUsedSlots10.toFixed(2) }} %</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="agencyStats" class="statistics-text-box elevation-3">
                        <h5>Durchschnittlich aktive Slots im 20er Segment:</h5>
                        <h3>{{ statisticsFromStatistics.percentageUsedSlots20.toFixed(2) }} %</h3>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="3">
                    <div v-if="agencyStats" class="statistics-text-box elevation-3">
                        <h5>Agenturen die angeworben wurden:</h5>
                        <h3>{{ agencyStats.agenciesWithReferredBy }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="agencyStats" class="statistics-text-box elevation-3">
                        <h5>Agenturen mit Betazugang:</h5>
                        <h3>{{ agencyStats.agenciesWithBetaAccess }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="agencyStats" class="statistics-text-box elevation-3">
                        <h5>Agenturen mit akzeptiertem Newsletter:</h5>
                        <h3>{{ agencyStats.agenciesWithNewsletter }}</h3>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="3">
                    <div v-if="agencyStats" class="statistics-text-box elevation-3">
                        <h5>Aktiver Subuser pro Agentur:</h5>
                        <h3>{{ agencyStats.averageSubusersPerAgency.toFixed(2) }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="agencyStats" class="statistics-text-box elevation-3">
                        <h5>Agenturen mit Subusern (mit lastSeen in den letzten 30 Tagen):</h5>
                        <h3>{{ agencyStats.agenciesWithActiveSubusers }}</h3>
                    </div>
                </v-col>
                <v-col cols="12" sm="3">
                    <div v-if="agencyStats" class="statistics-text-box elevation-3">
                        <h5>Subuser pro Slot:</h5>
                        <h3>{{ agencyStats.subuserPerAgencySlot.toFixed(3) }}</h3>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <angency-slots-distribution v-if="agencyStats" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <AgencyActiveCustomers v-if="agencyStats" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <angency-slots-per-value v-if="agencyStats" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="statistics-text-box elevation-3">
                        <h5>Informationen zu den Statistiken:</h5>
                        <p>Es fließen nur Agenturen in die Statistik ein, die eine Stripe Subscription ID besitzen und
                            mindestens einen Slot haben.</p>
                        <p>Die Statistiken wurden am <b>{{ statisticsAge }}</b> erstellt.</p>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>

import { mapState, mapActions } from 'vuex';
import AngencySlotsDistribution from '../charts/AgencySlotsDistribution.vue';
import AngencySlotsPerValue from '../charts/AgencySlotsPerValue.vue';
import AgencyActiveCustomers from '../charts/AgencyActiveCustomers.vue';

export default {
    components: {
        AngencySlotsDistribution,
        AngencySlotsPerValue,
        AgencyActiveCustomers
    },
    created() {
        this.loadStatistics();
    },
    computed: {
        ...mapState('statistics', ['agencyStats', 'loading', 'statisticsAge', 'statisticsFromStatistics'])
    },
    methods: {
        ...mapActions('statistics', ['fetchMostRecentStatistic']),
        async loadStatistics() {
            await this.fetchMostRecentStatistic();
        },
    },
}

</script>

<style lang="scss" scoped>
.table-statistics-wrapper {
    padding: 24px;
}


.statistics-text-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    font-weight: 500;
    border: 1px solid rgb(196, 196, 196);
    border-radius: 12px;
    padding: 12px;
}

.statistics-text-box p {
    font-weight: 400;
    font-size: 14px;
}
</style>